import HttpProvider from "@/providers/HttpProvider"
import { AxiosResponse } from "axios"
import { OldFilterDTO } from "../application/OldFilterDTO"
import { SortDTO } from "../application/SortDTO"
import { UrlHelper } from "../application/UrlHelper"
import { CarroceriaDTO } from "./CarroceriaDTO"

class CarroceriaAPI {

    private httpProvider: HttpProvider;

    constructor() {
        this.httpProvider = new HttpProvider()
    }

    public buscarCarrocerias(skip = 0, take = 100, sort: SortDTO, filter: OldFilterDTO): Promise<AxiosResponse<Array<CarroceriaDTO>>> {
        const encodedFilter = UrlHelper.buildFilterWithSortAndSkipTake(skip, take, sort, filter)
        return this.httpProvider.axiosInstanceBase.get(`/carroceria/v2?${encodedFilter}`)
    }

}


export default CarroceriaAPI
